import React from 'react';
import Paginations from '../../common/paginations';
import moment from 'moment';
import constant from '../../../constant';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const Index = ({ data, limit, handlePageChange }) => {
    const { page, total, projects, groups } = data;

    const renderTableHeader = () => (
        <thead>
            <tr>
                <th className="w500">Project</th>
                <th className="w150">Drawings</th>
            </tr>
        </thead>
    );

    const renderRow = (item) => (
        <tr key={item.PROJECT_ID}
        >
            <td>
                <p className="s1">
                    <Link
                        to={{
                            pathname: constant.Authedcomponent.finalDrawingDetail.url,
                            state: {
                                projectId: item.PROJECT_ID,
                                projectName: item.PROJECT_NAME
                            }
                        }}

                    >
                        {item.PROJECT_CODE} - {item.PROJECT_NAME}
                    </Link>
                </p>
            </td>

            <td>
                <p className="s1">{item.DRAWING_COUNT}</p>
            </td>
        </tr>
    );

    return (
        <React.Fragment>
            <table className="plan-approval-table">
                {renderTableHeader()}
                <tbody>
                    {groups
                        ? Object.entries(groups).map(([groupName, groupProjects]) => (
                            <React.Fragment key={groupName}>
                                <div className="company-name-hul">
                                    <h4>{groupName}</h4>
                                </div>
                                {groupProjects.map(renderRow)}
                            </React.Fragment>
                        ))
                        : projects?.length > 0
                            ? projects.map(renderRow)
                            : (
                                <tr>
                                    <td colSpan="4" className="text-center">No Record Found</td>
                                </tr>
                            )}
                </tbody>
            </table>

            <Paginations
                limit={limit}
                totalCount={total}
                range={5}
                currentPage={page}
                onPageChange={handlePageChange}
            />
        </React.Fragment>
    );
};

export default Index;
